import { Record } from 'immutable';
export default class ReenrollmentFilterOperation extends Record({
  lowerBoundTimestamp: null,
  numberOfDays: null,
  operator: null,
  propertyType: null,
  timestamp: null,
  timePoint: null,
  upperBoundTimestamp: null,
  value: null,
  values: null,
  comparisonPropertyName: null,
  propertyParser: null,
  endpointBehavior: null,
  lowerBoundTimePoint: null,
  upperBoundTimePoint: null,
  lowerBoundEndpointBehavior: null,
  upperBoundEndpointBehavior: null
}, 'ReenrollmentFilterOperation') {}